export default "__VITE_ASSET__1a9d6083__"